import { Pipe, PipeTransform } from '@angular/core';
import * as uniqId from 'lodash/uniqueId';

@Pipe({
  name: 'uniqueId'
})
export class UniqueIdPipe implements PipeTransform {

  public transform(prefix: string): string {
    return uniqId(prefix);
  }

}
